module.exports = __webpack_public_path__ + "static/media/codefellows.48c2ae45.png";